module.exports = __webpack_public_path__ + "static/media/terminal.fcb78c5d.svg";